// extracted by mini-css-extract-plugin
export var inverted = "FsANgqmLHI5l1DL8OlKj";
export var large = "ML9s1DcP9GKDVmxj3h70";
export var root = "zyIp4Z9YXf4AszEsxSpF";
export var spin = "KdE8D0JEGyTkkiNBE7Kw";